"use strict";

exports.__esModule = true;
exports.TitleText = exports.SearchIcon = exports.SearchDropdownTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TitleText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "components__TitleText",
  componentId: "sc-1ks0d5e-0"
})(["white-space:nowrap;"]);
exports.TitleText = TitleText;

var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    display: "inline-block",
    height: 24,
    ml: 4,
    width: 24
  }, /*#__PURE__*/_react["default"].createElement(_elements.NavSearch, {
    fill: "black",
    height: "100%",
    width: "100%"
  }));
};

exports.SearchIcon = SearchIcon;
var dropdownFont = {
  color: "text-title",
  fontSize: 2,
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: 2
};

var SearchDropdownTitle = function SearchDropdownTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(TitleText, _extends({
    display: ["none", "none", "inline-block"],
    overflow: "hidden",
    pr: 1,
    py: 12
  }, dropdownFont), children);
};

exports.SearchDropdownTitle = SearchDropdownTitle;
SearchDropdownTitle.propTypes = {
  children: _propTypes.node
};